import styled, { css } from 'styled-components';
import { Form } from '@unform/web';

interface MarginDATA {
  margin: string;
}

export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-top: 3.42rem;
  // margin-left: 4.4rem;
	padding: 3.9rem 1.5rem 5rem 5.5rem; // 4.42rem 1.5rem 5rem 5.5rem;
  // padding: 1rem 0; // 1rem;

  // 767px
  @media (max-width: 47.9375rem) {
    margin-left: 0;
		padding: 4.3rem 0.5rem 5rem;
  }
`;

export const Filtros = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px 10px;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
	border-radius: 8px;

	// 479px
  @media (max-width: 29.9375rem) {
		width: 100%;
		padding: 5px 0 10px;
	}
`;

export const FormView = styled(Form)`
  display: flex;
  align-items: center;

	.input-content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
		margin-right: 10px;

		:last-child {
			margin-right: 0;
		}

		span {
			font-size: 1rem;
			font-weight: 500;
			color: #455a64;
		}
	}

	.input-content-button {
		margin-left: 10px;
	}

	button {
		display: flex;
		background-color: #1a83ff;
		color: #fff;
		font-weight: 600;
		border-radius: 8px;
		padding: 9px 30px;

		svg {
			font-size: 20px;
			margin-right: 10px;
		}
	}

	// 479px
  @media (max-width: 29.9375rem) {
		flex-direction: column;
		width: 100%;
		margin: 0 5px;

		.input-content {
			div {
				padding: 2px 5px !important;

				input {
					font-size: 13px;
				}
			}
		};
		.input-content-button {
			margin-top: 5px;

			span {
				visibility: hidden;
				display: none;
			}
		};

		button {
			font-size: 13PX;
			padding: 9px 20px;

			svg {
				font-size: 18px;
			}
		}
	}
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1250px;

  .menu-button {
    margin: 0 5px;
    border: 0;

    svg {
      font-size: 25px;
      padding: 0;
    }
  }
  .menu-list {
    padding: 0 0;
    border-radius: 8px;

    .menu-item {
      font-family: 'Poppins';
      font-weight: 500;
      padding: 10px 10px 10px 20px;
      border-bottom: 1px solid #cbd5e0;

      :first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      :last-child {
        border-bottom: 0;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    }
  }

  @media (max-width: 1150px) {
    width: 850px;
  }
  @media (max-width: 1100px) {
    width: 750px;
  }
  @media (max-width: 780px) {
    width: 600px;
  }
  @media (max-width: 650px) {
    width: 500px;
  }
  @media (max-width: 450px) {
    width: 100%;
    max-width: 400px;
  }
`;

export const ListVazio = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

export const DivData = styled.div<MarginDATA>`
  display: flex;
  justify-content: center;

  svg {
    font-size: 20px;

    ${props =>
      props.margin === 'left'
        ? css`
            margin-left: 5px;
          `
        : css`
            margin-right: 5px;
          `}
  }
`;
